// extracted by mini-css-extract-plugin
export var container = "town-selection-view-module--container--f1dfb";
export var prefectureCityText = "town-selection-view-module--prefectureCityText--aed2f";
export var townLinkText = "town-selection-view-module--townLinkText--004f9";
export var townRow = "town-selection-view-module--townRow--b3b8f";